import {
	BaseIcon,
	Card,
	CardBody,
	CardHeader,
	CardHeading,
	Column,
	Empty,
	FormattedDate,
	Icon,
	Row,
	TextSpan,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { EventAnalyticsRatingResource } from "./analyticsTypes";

interface BaseProps {
	iconSrc: string;
	heading: string;
	events: EventAnalyticsRatingResource[];
}

const StyledIcon = styled(Icon)`
	width: 20px;
	height: 20px;
`;

const StyledBaseIcon = styled(BaseIcon)`
	width: 20px;
	height: 20px;
`;

const RatingRow = styled(Row)`
	justify-content: center;
	align-items: center;
`;

const dateFormat: Intl.DateTimeFormatOptions = {
	day: "2-digit",
	month: "2-digit",
	year: "2-digit",
};

const BasePerformerCard: FC<BaseProps> = ({ heading, events, iconSrc }) => {
	const { t } = useTranslation();
	return (
		<Card>
			<CardHeader>
				<CardHeading>
					<Row $gap={1}>
						<StyledBaseIcon src={iconSrc} /> {heading}
					</Row>
				</CardHeading>
			</CardHeader>
			<CardBody>
				{events.length === 0 && <Empty>{t("No matching events")}</Empty>}
				<Column $gap={4}>
					{events.map((event) => (
						<Row key={event.id} $justifyContent="space-between">
							<Column $gap={1}>
								<span>{event.name}</span>
								<TextSpan $size="small">
									<FormattedDate format={dateFormat} date={event.start} /> -{" "}
									<FormattedDate format={dateFormat} date={event.end} />
								</TextSpan>
							</Column>
							<RatingRow $gap={1}>
								<TextSpan $fontWeight="bold">{event.rating}</TextSpan>
								<StyledIcon $icon="star_filled" />
							</RatingRow>
						</Row>
					))}
				</Column>
			</CardBody>
		</Card>
	);
};

interface Props {
	events: EventAnalyticsRatingResource[];
}
export const TopPerformerCard: FC<Props> = ({ events }) => {
	const { t } = useTranslation();

	return <BasePerformerCard iconSrc="/trending_up.svg" heading={t("Top performer")} events={events} />;
};

export const LowPerformerCard: FC<Props> = ({ events }) => {
	const { t } = useTranslation();

	return <BasePerformerCard iconSrc="/trending_down.svg" heading={t("Low performer")} events={events} />;
};
